import client from '../../base-api';

const serviceURL = '/dashboard/site-manager';

const dashboardSiteManagerService = {

    getInfoData(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getUnitsDoneChart(filterData: any) {
        return client.get(`${serviceURL}/chart-data`, {params: filterData});
    },

    getPotentialUnits(filterData: any) {
        return client.get(`${serviceURL}/potential-units`, {params: filterData});
    },

    getPotentialUnitsExcelExport(filterData: any) {
        return client.get(`${serviceURL}/potential-units-excel-export`, {params: filterData});
    },

    getUnitsDonePerLocation(filterData: any) {
        return client.get(`${serviceURL}/units-done-per-location`, {params: filterData});
    },

    getUnsignedUnitsForLocation(filterData: any) {
        return client.get(`${serviceURL}/unsigned-units-for-location`, {params: filterData});
    },

    getCoachDashboard(id: any) {
        return client.get(`${serviceURL}/coach-dashboard/${id}`);
    },

    getCoachUnitsDoneChart(filterData: any, coachId: any) {
        return client.get(`${serviceURL}/coach-units-done-chart/${filterData?.year}/${filterData?.coachingType}/${coachId}`);
    },
}

export default dashboardSiteManagerService;